import { REVIEWS_SALES, REVIEWS_SERVICE } from 'client/constants/dealer-reviews';

export const DEFAULT_REVIEW_STATE = {
  averageRating: 0,
  recommended: 0,
  notRecommended: 0,
  totalCount: 0,
  newReviewsCount: 0,
};

export function getOverallRating(overallRatingByType, reviewsType) {
  if (!overallRatingByType) {
    return null;
  }

  switch (reviewsType) {
    case REVIEWS_SALES:
      return overallRatingByType.salesReview;
    case REVIEWS_SERVICE:
      return overallRatingByType.serviceReview;
    default: {
      // case REVIEWS_ALL: (todo - this logic should belong in the backend api)
      const salesReview = overallRatingByType.salesReview || DEFAULT_REVIEW_STATE;
      const serviceReview = overallRatingByType.serviceReview || DEFAULT_REVIEW_STATE;
      const returnValue = {
        notRecommended: salesReview.notRecommended + serviceReview.notRecommended,
        recommended: salesReview.recommended + serviceReview.recommended,
        totalCount: salesReview.totalCount + serviceReview.totalCount,
        newReviewsCount: salesReview.newReviewsCount + serviceReview.newReviewsCount,
      };
      returnValue.averageRating =
        (salesReview.averageRating * (salesReview.notRecommended + salesReview.recommended) +
          serviceReview.averageRating * (serviceReview.notRecommended + serviceReview.recommended)) /
        (returnValue.notRecommended + returnValue.recommended);
      return returnValue;
    }
  }
}
